<template>
    <div class="box">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl ">
                    Call Out
                </div>
                <a :href="`/master-admin/call-out/create?applicant=${userInfo.id}`"
                   class="btn btn--outline-primary btn--middle">+ Add New</a>
            </div>
            <div class="table-holder table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th>
                            <a href="javascript:void(0)" @click.prevent="changeSortList('date')">Shift Date<i
                                class="fas fa-sort"></i></a>
                        </th>
                        <th><nobr>Reason</nobr></th>
                        <th class="col-min-width">Status</th>
                        <th ><nobr>Shift Information</nobr></th>
                        <th>Comments</th>
                        <th class="text-right">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="call in callOuts"
                        :key="call.id"
                    >
                        <td>
                            <div class="text-14 color--text-gray">
                                {{formatDate(call.open_shift_timestamps) }}
                            </div>
                        </td>
                        <td>
                            <b>{{call.reason}}</b>
                        </td>
                        <td>
                            <span :class="{
                                'color--green': call.doctor_status === 'excused',
                                'color--red': call.doctor_status === 'unexcused'
                            }">
                                {{ call.doctor_status }}
                            </span>
                        </td>
                        <td>
                            <div>
                                <div>
                                   {{call.client.name}}
                                </div>
                                <div class="small-text">
                                    <span> {{calculateDate(call.open_shift_timestamps) }}</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex">
                                <span>{{call.comments}}</span>
                            </div>
                        </td>
                        <td class="text-right">
                            <div class="action-block">
                                <a href="javascript:void(0)"
                                   class="img-btn edit-link ml-2"
                                   @click="redirectToCallOut(call.id)"
                                ><img src="/img/svg/icons-pen.svg" alt="edit"></a>
                                <button
                                    class="img-btn delete-link"
                                    @click="showDeleteModal(call.id, 'call')"
                                ><img src="/img/svg/on.svg" alt=""></button>

                                <ActionModal confirm-text="Yes"
                                             reject-text="No"
                                             :modalId="getDeleteModalId(call.id, 'call')"
                                             @confirm="deleteCallOut(call.id)">
                                    <template #body>
                                        <div class="text-center mb-4">
                                            <h4>
                                                Are you sure you want <br> to delete this item?
                                            </h4>
                                        </div>
                                    </template>
                                </ActionModal>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-between">
                <Pagination
                    class="ml-1 mr-1"
                    :currentPage="pagination.current_page"
                    :lastPage="pagination.last_page"
                    @changeItemsPerPage="changeItemsPerPage"
                    @changePage="changePage"/>
            </div>
        </div>
    </div>
</template>

<script>
import ApplicantsServices from "../services/ApplicantsServices";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import CallOutService from "../../../../CallOut/resources/js/services/CallOutService";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import SortDirectionHandler from "../../../../../../resources/js/mixins/SortDirectionHandler";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import Pagination from "../../../../../../resources/js/components/Pagination.vue";

export default {
    name: 'CallOut',
    components: {Pagination, ActionModal},
    props: {
        userInfo: {
            type: Object
        }
    },
    mixins: [DateConverter, ModalHandler, SortDirectionHandler, PaginationHandler ],
    data() {
        return {
            callOuts: [],
            filters: {
                sortBy: 'date',
                sortDir: 'asc',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        getList(filters) {
            this.getApplicantCallOutInfo(filters)
        },
        async deleteCallOut(id) {
            this.$showLoadingMessage()
            this.callOuts = this.callOuts.filter((call) => call.id !== id)
            try {
                await CallOutService.deleteCallOut(id)
                await this.getApplicantCallOutInfo()
                this.$showSuccessMessageDelete('Call Out was successfully deleted');
            } catch (error) {
                this.$showErrorMessage('Call Out was not deleted. Please reload page and try again');
            }
        },
        async getApplicantCallOutInfo() {
            try {
                const {data: response} = await ApplicantsServices.getApplicantCallOut(this.userInfo.id, this.filters)
                this.callOuts = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('call out was not uploaded')
            }
        },
        redirectToCallOut(callId) {
            window.location.href = `/master-admin/call-out/${callId}/update?applicant=${this.userInfo.id}`
        }
    },
    mounted() {
        this.getApplicantCallOutInfo()
    }
}

</script>

<style scoped>

</style>
